exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".green-fab {\r\n    background-color: #3eb049;\r\n    position: relative;\r\n    top: 20px;\r\n    left: 50px;\r\n}\r\n\r\n.mat-datepicker-content-touch {\r\n  overflow: hidden;\r\n  margin: 0px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/calendar/calendar.component.css
// module id = ../../../../../src/app/calendar/calendar.component.css
// module chunks = main